if (!customElements.get('article-toc')) {
  class ArticleToc extends HTMLElement {
    connectedCallback() {
      this.list = this.querySelector('[data-article-toc-list]');
      this.content = document.querySelector(this.getAttribute('data-content-selector'));

      if (!this.list || !this.content) return;

      // Index the article body headings + the "Image with text" banners, but
      // exclude the product carousel and the whole "Blog posts" related grid
      // (its title and every blog-post card link) so the index stays relevant.
      this.headings = Array.from(this.content.querySelectorAll('h2')).filter(
        (heading) =>
          !heading.closest(
            '[data-toc-exclude], [data-section-type="product-carousel"], [data-section-type="blog"]'
          )
      );

      if (!this.headings.length) {
        this.closest('.widget')?.remove();
        return;
      }

      this.slugs = {};
      this.items = this.headings.map((heading, index) => this.buildItem(heading, index));
      this.bindClicks();
      this.observe();
    }

    disconnectedCallback() {
      this.observer?.disconnect();
    }

    slugify(text) {
      const base = text
        .toLowerCase()
        .trim()
        .replace(/['']/g, '')
        .replace(/[^a-z0-9]+/g, '-')
        .replace(/(^-+|-+$)/g, '');

      const slug = base || 'section';
      const count = this.slugs[slug] || 0;
      this.slugs[slug] = count + 1;

      return count === 0 ? slug : `${slug}-${count + 1}`;
    }

    buildItem(heading, index) {
      if (!heading.id) {
        heading.id = this.slugify(heading.textContent);
      }

      const li = document.createElement('li');
      const link = document.createElement('a');

      link.classList.add('widget__link');
      link.href = `#${heading.id}`;
      link.textContent = `${index + 1}. ${heading.textContent.trim()}`;

      li.appendChild(link);
      this.list.appendChild(li);

      return { heading, link, li };
    }

    bindClicks() {
      this.items.forEach(({ heading, link }) => {
        link.addEventListener('click', (event) => {
          event.preventDefault();

          if (window.theme && typeof window.theme.scrollTo === 'function') {
            window.theme.scrollTo(heading.getBoundingClientRect().top);
          } else {
            heading.scrollIntoView({ behavior: 'smooth' });
          }

          history.pushState(null, '', `#${heading.id}`);
        });
      });
    }

    observe() {
      if (!('IntersectionObserver' in window)) return;

      this.observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;

            const match = this.items.find((item) => item.heading === entry.target);
            if (match) this.setActive(match);
          });
        },
        {
          rootMargin: '-15% 0px -70% 0px',
          threshold: 0,
        }
      );

      this.items.forEach(({ heading }) => this.observer.observe(heading));
    }

    setActive(activeItem) {
      this.items.forEach(({ li }) => {
        li.classList.toggle('widget__links--active', li === activeItem.li);
      });
    }
  }

  customElements.define('article-toc', ArticleToc);
}
